import React, { useEffect, useState } from 'react';

import { ProductOrPrize } from '../types/game';
import { Product } from '../hooks/useProducts';
import { ProductCard, PrizeCard } from './card';
import './ProductGrid.css';

export interface ProductGridProps {
  items: ProductOrPrize[];
  selectedProduct: Product | null;
  handleProductClick: (product: Product) => void;
  handlePrizeClick: (prizeId: string, event: React.MouseEvent<HTMLElement>) => void;
  allPrizesCollected: boolean;
  isLoadingCategory?: boolean;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  items,
  selectedProduct,
  handleProductClick,
  handlePrizeClick,
  allPrizesCollected,
  isLoadingCategory = false,
}) => {
  const renderProductOrPrize = (item: ProductOrPrize, index: number) => {
    if (item.type === 'product') {
      return (
        <ProductCard
          product={item.item}
          isSelected={selectedProduct?.id === item.item.id}
          onClick={handleProductClick}
          allPrizesCollected={allPrizesCollected}
        />
      );
    } else {
      return (
        <PrizeCard prize={item.item} onClick={handlePrizeClick} />
      );
    }
  };

  return (
    <div className={`product-grid ${isLoadingCategory ? 'loading-category' : ''}`}>
      {items.length === 0 ? (
        <div className="loading-products">Loading products...</div>
      ) : (
        items.map((item, index) => (
          <React.Fragment key={item.type === 'product' ? item.item.id : `${item.item.id}-${index}`}>
            {renderProductOrPrize(item, index)}
          </React.Fragment>
        ))
      )}
    </div>
  );
};

export default ProductGrid;
